import React from "react";
import { Icon } from "@chakra-ui/icons";

import { ReactComponent as ArrowRightLineIcon } from "../../assets/arrow-right-line.svg";

export const ArrowRightLine = (props) => {
  return <Icon as={ArrowRightLineIcon} {...props} />;
};
